const COUNTRIES = [
  { name: "Estados Unidos", code: "+1" },
  { name: "México", code: "+52" },
  { name: "Argentina", code: "+54" },
  { name: "España", code: "+34" },
  { name: "Colombia", code: "+57" },
  { name: "Chile", code: "+56" },
];

export default COUNTRIES;
